import "../../pages/App.css";
import { HeaderMain } from "../../components/home/header/Header.js";
import EventCard from "../../components/events/card/EventCard.js";
import OrionHubImage from "../../assets/background/orionhub.svg";
import OrionHub2026Banner from "../../assets/background/banner doity 1.jpg.jpeg";

const events = [
  {
    id: 2,
    title: "OrionHub 2026 - Da pesquisa à inovação",
    location: "Hotel Jatiúca · Maceió, AL",
    date: "28 e 29 de agosto de 2026",
    image: OrionHub2026Banner,
    buttonText: "Saiba mais",
    buttonUrl: "/orionhub",

  },
  {
    id: 1,
    title: "Ciencia de dados aplicada as cidades inteligentes",
    location: "Centro de Inovação do Jaraguá",
    date: "30 e 31 de janeiro das 09:00 as 20:00h",
    image: OrionHubImage,
    buttonText: "Evento encerrado",
    buttonUrl: "",
    buttonDisabled: true,
  },
];

function EventosPage() {
  return (
    <div
      className="App"
      style={{
        background: "linear-gradient(to bottom right, #6BCF7F 0%, #EFFFEF 20%, #FFFFFF 50%)",
        minHeight: "100vh",
        padding: "0",
      }}
    >
      <HeaderMain />
      <div className="eventContent" style={{ paddingLeft: "35px" }}>
        <h1 style={{ color: "#252B42", fontSize: "36px", textAlign: "left" }}>Eventos</h1>
        <p style={{ color: "#374754", fontSize: "18px", textAlign: "left" }}>
          Descubra os proximos eventos e atividades do Orion.
        </p>

        <div
          style={{
            padding: "30px 30px 30px 0",
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            justifyContent: "left",
          }}
        >
          {events.map((event) => (
            <div
              key={event.id}
              style={{
                flex: "1 1 calc(100% - 16px)",
                boxSizing: "border-box",
                maxWidth: "400px",
              }}
            >
              <EventCard
                title={event.title}
                location={event.location}
                date={event.date}
                image={event.image}
                buttonText={event.buttonText}
                buttonUrl={event.buttonUrl}
                status={event.status}
                buttonDisabled={event.buttonDisabled}
              />
            </div>
          ))}
        </div>
      </div>

      <style>
        {`
          @media (min-width: 768px) {
            .App > div > div > div {
              flex: 1 1 calc(50% - 16px);
            }
          }
          @media (min-width: 1024px) {
            .App > div > div > div {
              flex: 1 1 calc(33.33% - 16px);
            }
          }
        `}
      </style>
    </div>
  );
}

export default EventosPage;
